<ion-header mode="md">
  <ion-toolbar class="ion-text-center">
    <ion-item lines="none">
      <ion-img
        class="logo"
        *ngIf="p.renderMobile"
        src="../assets/images/app-logo.svg"
      ></ion-img>
    </ion-item>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-card class="push-acceptation__cart">
    <div>
      <ion-card-header class="push-acceptation__header">
        <ion-card-title>
          <ion-item lines="none">
            <ion-thumbnail>
              <img src="assets/images/Push.svg" />
            </ion-thumbnail>
            <ion-label class="push-acceptation__title">{{
              "FIRST_RUN.PUSH" | translate
            }}</ion-label>
          </ion-item>
        </ion-card-title>
      </ion-card-header>

      <ion-card-content class="push-acceptation__content">
        <p>{{ "FIRST_RUN.PUSH_DESCRIPTION" | translate }}</p>
        <p>{{ "FIRST_RUN.PUSH_INFO" | translate }}</p>
      </ion-card-content>
    </div>

    <ion-item lines="none" class="push-acceptation__buttons-container">
      <ion-grid class="w-100">
        <ion-row>
          <ion-button
            (click)="onConfirm()"
            class="push-acceptation__button-accept"
            size="medium"
          >
            {{ "FIRST_RUN.PUSH_ACCEPT_BUTTON" | translate }}
          </ion-button>
        </ion-row>
        <ion-row>
          <ion-button
            (click)="onReject()"
            class="push-acceptation__button-skip"
            Fill="clear"
            [expand]="'block'"
            size="medium"
          >
            {{ "FIRST_RUN.SKIP" | translate }}</ion-button
          >
        </ion-row>
      </ion-grid>
    </ion-item>
  </ion-card>
</ion-content>
